import { UserTableHeader } from "./UserTableHeader";
import { UserTableRow } from "./UserTableRow";
import type { User } from "@/services/api/users";
import type { Category } from "@/services/api/categories";
import type { SortField, SortDirection } from "./userUtils";

interface UserTableProps {
  users: User[];
  categories: Category[];
  sortField: SortField;
  sortDirection: SortDirection;
  isLoading: boolean;
  isLoadingCategories: boolean;
  isUpdatingPermissions: boolean;
  currentUserEntraId: string | null;
  onSort: (field: SortField) => void;
  onTogglePermission: (
    user: User,
    category: Category,
    checked: boolean
  ) => void;
  onDelete: (user: User) => void;
}

export function UserTable({
  users,
  categories,
  sortField,
  sortDirection,
  isLoading,
  isLoadingCategories,
  isUpdatingPermissions,
  currentUserEntraId,
  onSort,
  onTogglePermission,
  onDelete,
}: UserTableProps) {
  if (isLoading) {
    return (
      <div className="py-12 text-center text-sm text-ink-500">
        Loading users...
      </div>
    );
  }

  if (users.length === 0) {
    return (
      <div className="py-12 text-center text-sm text-ink-500">
        No users found.
      </div>
    );
  }

  return (
    <div className="max-h-[70vh] overflow-auto pb-8">
      <table className="w-full">
        <UserTableHeader
          sortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <tbody className="divide-y divide-grid-200 text-sm text-ink-800">
          {users.map((user) => (
            <UserTableRow
              key={user.entraObjectId || user.id}
              user={user}
              categories={categories}
              isLoadingCategories={isLoadingCategories}
              isUpdatingPermissions={isUpdatingPermissions}
              isSelf={currentUserEntraId != null && user.entraObjectId === currentUserEntraId}
              onTogglePermission={onTogglePermission}
              onDelete={onDelete}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
